import React from 'react';
import { productCategory } from '../services/mapper';
import { API_URL } from '../config';
import { isString } from 'util';

const TOKEN = 'token'

const initialNetworkCtx = {
    networkCtx: {
        mapper: productCategory,
        status: { called: false, data: [], loading: true, error: false, parsedData: [] },
        notRequested: true
    },
    setNetworkCtx: () => null,
    sendNetworkRequest: () => null
}

const sendNetworkRequest = async (url, params, data, auth = false, silentErrors = false) => {
    url = API_URL+url;
    console.info('URL', url, data)
    const method = data ? 'POST' : 'GET', 
        headers = {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        };
    let resdata = null;
   // if(auth){
        const token = localStorage.getItem(TOKEN)

        if(token) headers["authorization"] = `Bearer ${token}`
       // else window.location = '/'
    //}
    const fetchOptions = { method, headers };
    if (method === 'POST' && data != null) {
        fetchOptions.body = isString(data) ? data : JSON.stringify(data);
    }
    const response = await fetch(url, fetchOptions)

    if(response.status < 400){
        resdata = await response.json();
    } else if (response.status === 403)
	{
		window.location = '/'
	}
	else {
        try {
            resdata = await response.json();
        } catch (e) {
            resdata = { statusCode: response.status, message: response.statusText };
        }
        if (!silentErrors) {
            alert(`${response.status}:${response.statusText} - Unable to complete your request to \n${url}`)
        }
    }
    return resdata;
}

export const NetworkContext = React.createContext(initialNetworkCtx);

export const NetworkConsumer = NetworkContext.Consumer;

export const NetworkProvider = (props) => {

    const [ networkCtx, setNetworkCtx ] = React.useState(initialNetworkCtx.networkCtx);

    return(
        <NetworkContext.Provider value={{ networkCtx, setNetworkCtx, sendNetworkRequest }} >
            {props.children}
        </NetworkContext.Provider>
    )
}